// extracted by mini-css-extract-plugin
export default {"dividerContainer":"SectionDivider_dividerContainer__wGIGB","dividerImage":"SectionDivider_dividerImage__UKA9T"};